import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TrainingService } from '../training.service';
import { Observable } from 'rxjs';
import { YoungEaglesVoucher } from '../components/models/young-eagles-voucher-model';

@Injectable({
  providedIn: 'root'
})
export class YoungEaglesService {

  api = null;

  constructor(private httpClient: HttpClient, private trainingService: TrainingService) {
    this.trainingService.load().subscribe(value => {
      this.api = value;
      });
  }

  verifyVoucher(voucherId: string): Observable<any> {
      return this.httpClient.get(this.api.getRoute('youngEaglesVerifyVoucherUrl').replace('{voucherId}', voucherId));
  }

  public redeemVoucher(voucherId: string, updateVoucherRequest: YoungEaglesVoucher): Observable<any> {
    return this.httpClient.put<any>(this.api.getRoute('youngEaglesRedeemVoucherUrl').replace('{voucherId}', voucherId), updateVoucherRequest);
  }

}
